"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const useFormGroup_1 = require("../../hooks/useFormGroup");
const tools_1 = require("../../tools");
const Box_1 = require("../Box");
exports.SelectInput = react_1.forwardRef(function SelectInput(props, ref) {
    const { colors } = hooks_1.useTheme();
    const { id } = useFormGroup_1.useFormGroup();
    return (jsx_runtime_1.jsxs(Box_1.Box, Object.assign({ position: "relative" }, { children: [jsx_runtime_1.jsx(StyledBox, Object.assign({ as: "select", border: props.variant === 'inline' ? 'none' : '1px solid rgba(125,125,125,0.5)', fontFamily: "'Roboto', sans-serif !important", borderRadius: 4, lineHeight: 1.45, fontWeight: props.variant === 'inline' ? 'bold' : 300, mr: props.variant === 'inline' ? '1.1rem' : '2rem', display: "block", fontSize: "md", width: "100%", boxShadow: props.variant === 'inline' ? 0 : 1, _focus: { boxShadow: '0 0 2px 2px ' + colors.selected, borderColor: 'transparent' }, _disabled: { backgroundColor: 'rgba(125,125,125,0.1)' }, py: props.variant === 'inline' ? 0 : 2, px: props.variant === 'inline' ? 1 : 3, id: id }, props, { ref: ref }), void 0),
            jsx_runtime_1.jsx(Box_1.Box, Object.assign({ position: "absolute", right: props.variant === 'inline' ? 0 : '1rem', top: "50%", transform: "translateY(-45%)", color: "#000" }, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronDown }, void 0) }), void 0)] }), void 0));
});
const StyledBox = tools_1.styled(Box_1.Box) `
  outline: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  ::-ms-expand {
    display: none;
  }
`;
//# sourceMappingURL=index.js.map